const layout = () => import("../../internal/layout.vue");
const pdv = () => import("./pdv.vue");

const pdvRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "pdv",
      meta: {
        title: "MATERIAL DE APOIO À VENDA",
        requiresAuth: true,
      },
      component: pdv,
    },
  ],
};

export default pdvRoutes;
